// extracted by mini-css-extract-plugin
module.exports = {"readMore":"ReadMore__readMore__2ZoVT","ellipsis":"ReadMore__ellipsis__DZofE"};